// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"zn-z"};